import { useFormContext, useWatch } from "react-hook-form";
import { SetpointFormType} from "../AlarmSetpointEditorUtils";
import { FormControl,  InputLabel,  MenuItem,  SelectChangeEvent  } from "@mui/material";
import FormProperty from "../../forms/form-property/FormProperty";
import { useUserContext } from "../../../contexts/user-context/UserContext";
import { useQueryNotifications } from "../../../queries/UseQueryNotifications";
import { useGroup } from "../../../queries/groups/UseGroup";
import { useTranslation } from "react-i18next";
import FormInput from "../../forms/form-input/FormInput";
import AlarmSetpointMessagingUtils, { MessageTemplateTypeEnum } from "./AlarmSetpointMessagingUtils";
import { useSetpointReferenceData } from "../../../queries/alarm-setpoint-admin/UseSetpointReferenceData";
import { useRef } from "react";
import DefaultSelect from "../../default-select/DefaultSelect";

export type AlarmSetpointMessageEditorProps = {
    groupID: number,
    templateType: MessageTemplateTypeEnum
};

export default function AlarmSetpointMessageEditor({
    groupID,
    templateType
    
}: AlarmSetpointMessageEditorProps) {

    const timerRef = useRef(-1);

    const name = AlarmSetpointMessagingUtils.getFormPropertyName(templateType);
    const sampleName = AlarmSetpointMessagingUtils.getFormPropertySampleName(templateType);
    const label = AlarmSetpointMessagingUtils.getFormPropertyLabel(templateType);

    const { t } = useTranslation();
    const [userState] = useUserContext();

    const {data: group } = useQueryNotifications(useGroup)({
        customerID: userState.customer?.id as number,
        groupID
    });

    const {
        getValues,
        //watch,
        trigger,
        control,
        //reset,
        setValue,
        //resetField
    } = useFormContext<SetpointFormType>();    

    const setpoint = useWatch({ control: control }) as SetpointFormType;    

    const organizationID = setpoint.setPointID > 0 ? setpoint.organizationID : group?.organizationID as number;

    const {data: referenceData /*status: referenceStatus */} = useQueryNotifications(useSetpointReferenceData)({
        groupID ,
        organizationID: organizationID,
        enabled: groupID !== undefined
    });

    const messages = AlarmSetpointMessagingUtils.getMessageTemplates(templateType, setpoint.dataType, referenceData?.messages ?? []);

    function onContentSelected(event: SelectChangeEvent<string>) {

        let value = getValues(name);
        value += event.target.value;


        setValue(name, value);
        setValue(sampleName, '');

        trigger();
    }

    function onContentChanged() {

        //console.log(`timerID : ${timerRef.current}`)

        if (timerRef.current === -1) {
            timerRef.current = window.setTimeout(() => {
                //console.log('bad food')
                setValue(sampleName, '');
                timerRef.current = -1;
        
            }, 2000);
        }
    }

   return (
    <FormProperty>

        <FormControl sx={{ 
                width: 1,
                marginTop: 1,
        }}>
                <InputLabel id="select-template-label">
                    {t('setpointAdmin.messaging.reusableContent')}
                </InputLabel>
                <DefaultSelect
                    labelId="select-template-label"
                    id="select-template"
                    value={''}
                    label={t('setpointAdmin.messaging.reusableContent')}
                    onChange={onContentSelected}
                >
                    <MenuItem value="" 
                        disabled={true}>
                    </MenuItem>

                    {messages?.map((o, index) => 
                        <MenuItem key={index} value={o.template}>
                            {o.friendlyName}
                        </MenuItem>
                    )}

                </DefaultSelect>
        </FormControl>

        <FormInput
            name={name}
            label={label}
            sx={{
                width: 1,
                marginTop: 1,
            }}

            onChange={() => onContentChanged()}
            multiline={true}
            rows={4}
            rules={{
                required: {
                    value: templateType !== MessageTemplateTypeEnum.VoiceAlarmMessage && 
                            templateType !== MessageTemplateTypeEnum.VoiceClearMessage,
                    message: t('setpointAdmin.messaging.templateRequired', {name: label})
                }, 
            }}
        /> 
    </FormProperty>



   );
  }
